import { TRANSACTION_COMBO_ID_FIELD } from './columnConfig';

export const tableConfig = {
  index: TRANSACTION_COMBO_ID_FIELD,
  renderVerticalBuffer: 1500,
};
